import { COMPANY_EINS } from "../types";
const CompanyEins = (state = [], action) => {
    if (action.type === COMPANY_EINS) {
        state = action.payload;
    };
    return state;
};

export default CompanyEins;